/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { update } from '../../services/item';
import { LinkSortable } from './link.Sortable';
import { canEditItemForItem, getId } from '../../utils/item';
import { LinkNew } from './link.New';
import { NavigationView } from '../navigation/navigation.View';
import { FaEdit, FaEye } from 'react-icons/fa';
import { isTouchOnlyContext } from '../../utils/inputCapabilities';
import { isEditable } from '../../utils/roles';

export const LinkAll = props => {
  const { itemId } = props;

  const item = useSelector(state => state.items[itemId]);
  const isMobile = useSelector(state => state.global.isMobile);
  const isTouch = useSelector(state => state.global.isTouch);
  const items = useSelector(state => state.items);
  const [links, setLinks] = useState([]);
  const [shouldPersistOrder, setShouldPersistOrder] = useState(false);
  const [displaySection, setDisplaySection] = useState('Vue');
  const canEdit = canEditItemForItem(item, items);
  const touchLocked = isTouchOnlyContext(isTouch);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  function handleDragEnd(event) {
    const { active, over } = event;
    if (!over || active.id === over.id) {
      return;
    }
    if (active.id !== over.id) {
      setLinks(prev => {
        const oldIndex = prev.findIndex(
          item => Object.keys(item)[0] === active.id
        );
        const newIndex = prev.findIndex(
          item => Object.keys(item)[0] === over.id
        );
        return arrayMove(prev, oldIndex, newIndex);
      });
      setShouldPersistOrder(true);
    }
  }

  useEffect(() => {
    if (item?.links) {
      setLinks(item.links);
    }
    setShouldPersistOrder(false);
  }, [item?.links]);

  useEffect(() => {
    if (!shouldPersistOrder) {
      return;
    }
    if (
      links?.length === item?.links?.length &&
      JSON.stringify(links) !== JSON.stringify(item?.links)
    ) {
      update(`items/${itemId}`, 'links', links).finally(() =>
        setShouldPersistOrder(false)
      );
    } else {
      setShouldPersistOrder(false);
    }
  }, [shouldPersistOrder, links, item?.links, itemId]);

  return (
    <div>
      {links.length > 0 && (
        <div className='flex gap-1 px-1 items-center font-condensed uppercase text-xl mt-1 mb-05 text-primary-l'>
          Liens
          <div className='border-b border-primary flex-1'></div>
          <div className='flex items-center gap-05 text-contrast'>
            {isEditable() && canEdit &&
              ['Tous'].map(sortBy => (
                <div
                  key={sortBy}
                  className={`text-xs uppercase rounded px-05 py-02 cursor-pointer transition hover:opacity-50 ${
                    displaySection === sortBy
                      ? 'bg-secondary'
                      : 'bg-primary opacity-50'
                  }`}
                  onClick={() =>
                    setDisplaySection(
                      displaySection === 'Tous' ? 'Vue' : 'Tous'
                    )
                  }
                >
                  {sortBy === 'Tous' ? <FaEdit /> : <FaEye />}
                </div>
              ))}
          </div>
        </div>
      )}
      {isEditable() && canEdit && <LinkNew itemId={itemId} />}
      {displaySection === 'Vue' ? (
        <NavigationView
          inFolder={false}
          parentId={item?._id}
          viewId={item?.view}
        />
      ) : (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={links.map(linkObj => getId(linkObj))}
            strategy={verticalListSortingStrategy}
            disabled={
              isMobile || touchLocked || isEditable() === false || !canEdit
            }
          >
            {links.map(linkObj => (
              <LinkSortable
                key={getId(linkObj)}
                id={getId(linkObj)}
                itemId={itemId}
                displayType={'expandable'}
                linkId={getId(linkObj)}
                // deleteLink={deleteLink}
                // setOpenDrawer={setOpenDrawer}
              />
            ))}
          </SortableContext>
        </DndContext>
      )}
    </div>
  );
};
